var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpecial = function SvgSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "m7.05 16.204-4.829-2.415 4.83-2.415a1.6 1.6 0 0 0 .716-.716L10.18 5.83l2.415 4.83a1.6 1.6 0 0 0 .716.715l4.83 2.415-4.83 2.415a1.6 1.6 0 0 0-.716.716l-2.415 4.83-2.414-4.83a1.6 1.6 0 0 0-.716-.716ZM17.53 5.831l-1.49-.745 1.49-.745a1.4 1.4 0 0 0 .627-.626l.745-1.491.745 1.49c.136.271.355.491.626.627l1.49.745-1.49.745.447.895-.447-.895a1.4 1.4 0 0 0-.626.626l-.745 1.49-.745-1.49a1.4 1.4 0 0 0-.627-.626Z"
  })));
};
export default SvgSpecial;